
module.exports = {
    myHost: {
        // 'host':'http://192.168.68.118:8080',
        // 'host':'https://api-v2.smicee.com',
        // 'host':'https://api-demo.smicee.com',
        // 'host':'https://api-digital.smicee.com',
        // 'host':'https://api-pixeltag.smicee.com',
        'host':'https://api-catchbd.smicee.com',
        // 'host':'https://migrate.smicee.com',
    }
};
